import { createRequiredContext } from '@festina-life/ui/libs'

import type { EnvironmentSettings } from '../settings/fetchAppSettings'
import type { EnvironmentSettingsWithApi } from '../utility/getEnvironmentSettings'

export type PseudonymizationSettings = {
  moneyOut: {
    paymentChannel: boolean
    payableStop: boolean
  }
}

export type AuthenticationContextType = {
  api: string | null
  environmentSettings: EnvironmentSettings | null
  onChangeEnvironmentSettings: (
    nextSettings: EnvironmentSettingsWithApi,
  ) => void
  shouldValidateAuthenticationHooks: boolean
  onChangeShouldValidateAuthenticationHooks: (
    shouldValidateAuthenticationHooks: boolean,
  ) => void
  isInTestMode: boolean
  isUsingExternalCrm: boolean
  shouldShowUserInfo: boolean
  pseudonymization: PseudonymizationSettings | undefined
  setShouldShowUserInfo: (shouldShowUserInfo: boolean) => void
}

/** Configuration context for a life App. */
const [useAuthenticationContext, Provider] =
  createRequiredContext<AuthenticationContextType>('Authentication')

export { Provider, useAuthenticationContext }
